import React from 'react';


const Send = () => {
	return (<svg viewBox="0 0 480 480">
		<polygon points="0.213,32 0,181.333 320,224 0,266.667 0.213,416 448,224 		"/>
	</svg>);
};

export default Send;